import { Outlet } from 'react-router-dom';
import AuthBackground from '../../../public/auth-background.png';

export function OnboardingPage() {
  return (
    <div
      className="flex flex-col h-screen sm:h-screen w-full bg-auth-bg bg-repeat md:bg-cover bg-center overflow-y-auto"
      style={{
        backgroundImage: `url(${AuthBackground})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}
    >
      {/* Content Area */}
      <div className="flex-grow flex justify-center items-center p-4">
        <Outlet />
      </div>
    </div>
  );
}
